export default function formatDate(
  str,
  options = {
    day: "2-digit",
    month: "long",
    year: "numeric",
  },
) {
  const date = new Date(str);

  return date.toLocaleDateString("pt-BR", {
    ...options,
    timeZone: "America/Cuiaba",
  });
}
